import { useQuery } from "@tanstack/react-query";
import {
  getAvatarAboutById,
  getAvatarFitById,
  getAvatarObjectionsById,
  getAvatarPainById,
  getAvatarSituationById,
  getAvatarVerbatimsById,
} from "@/app/actions/client-avatar/get/action";
import { AvatarQuerySubKey, QueryKey } from "@/app/vars/QueryKeys";

export function useFetchAvatarAbout(options: { avatarId?: number; enabled?: boolean } = {}) {
  const { avatarId, enabled = true } = options;
  return useQuery({
    queryKey: [QueryKey.CLIENT_AVATAR, AvatarQuerySubKey.DETAIL, avatarId, AvatarQuerySubKey.ABOUT],
    queryFn: () => getAvatarAboutById(avatarId!),
    enabled: enabled && !!avatarId && avatarId !== -1,
    staleTime: Infinity,
  });
}

export function useFetchAvatarPain(options: { avatarId?: number; enabled?: boolean } = {}) {
  const { avatarId, enabled = true } = options;
  return useQuery({
    queryKey: [QueryKey.CLIENT_AVATAR, AvatarQuerySubKey.DETAIL, avatarId, AvatarQuerySubKey.PAIN],
    queryFn: () => getAvatarPainById(avatarId!),
    enabled: enabled && !!avatarId && avatarId !== -1,
    staleTime: Infinity,
  });
}

export function useFetchAvatarSituation(options: { avatarId?: number; enabled?: boolean } = {}) {
  const { avatarId, enabled = true } = options;
  return useQuery({
    queryKey: [
      QueryKey.CLIENT_AVATAR,
      AvatarQuerySubKey.DETAIL,
      avatarId,
      AvatarQuerySubKey.SITUATION,
    ],
    queryFn: () => getAvatarSituationById(avatarId!),
    enabled: enabled && !!avatarId && avatarId !== -1,
    staleTime: Infinity,
  });
}

export function useFetchAvatarObjections(options: { avatarId?: number; enabled?: boolean } = {}) {
  const { avatarId, enabled = true } = options;
  return useQuery({
    queryKey: [
      QueryKey.CLIENT_AVATAR,
      AvatarQuerySubKey.DETAIL,
      avatarId,
      AvatarQuerySubKey.OBJECTIONS,
    ],
    queryFn: () => getAvatarObjectionsById(avatarId!),
    enabled: enabled && !!avatarId && avatarId !== -1,
    staleTime: Infinity,
  });
}

export function useFetchAvatarVerbatims(options: { avatarId?: number; enabled?: boolean } = {}) {
  const { avatarId, enabled = true } = options;
  return useQuery({
    queryKey: [
      QueryKey.CLIENT_AVATAR,
      AvatarQuerySubKey.DETAIL,
      avatarId,
      AvatarQuerySubKey.VERBATIMS,
    ],
    queryFn: () => getAvatarVerbatimsById(avatarId!),
    enabled: enabled && !!avatarId && avatarId !== -1,
    staleTime: Infinity,
  });
}

export function useFetchAvatarFit(options: { avatarId?: number; enabled?: boolean } = {}) {
  const { avatarId, enabled = true } = options;
  return useQuery({
    queryKey: [QueryKey.CLIENT_AVATAR, AvatarQuerySubKey.DETAIL, avatarId, AvatarQuerySubKey.FIT],
    queryFn: () => getAvatarFitById(avatarId!),
    enabled: enabled && !!avatarId && avatarId !== -1,
    staleTime: Infinity,
  });
}
